export const METRICA_ID = process.env.VUE_APP_YANDEX_METRICA_ID || 97130115;

export function setMetricaUser(userId) {
  if (typeof window !== 'undefined' && window.ym && METRICA_ID) {
    if (userId) {
      window.ym(Number(METRICA_ID), 'setUserID', String(userId));
      window.ym(Number(METRICA_ID), 'userParams', {
        userID: String(userId),
        userRole: 'Student'
      });
    } else {
      window.ym(Number(METRICA_ID), 'setUserID', null);
    }
  }
}

export function trackMetricaHit(path, title) {
  if (typeof window !== 'undefined' && window.ym && METRICA_ID) {
    window.ym(Number(METRICA_ID), 'hit', path, {
      title: title || document.title
    });
  }
}
